import { getAccessToken } from '@/services/auth-service'
import { env } from '@/lib/env'

const BACKEND_URL = env.backendApiUrl

export interface TranslateResponse {
  translated_text: string
  detected_language: string
}

/**
 * Translate text between German and English via BFF → CDB-TQS.
 */
export async function translateText(
  text: string,
  targetLanguage: 'de' | 'en',
  signal?: AbortSignal,
): Promise<TranslateResponse> {
  const token = getAccessToken()
  const response = await fetch(`${BACKEND_URL}/api/v1/translate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ text, target_language: targetLanguage }),
    signal,
  })

  if (!response.ok) {
    throw new Error(`Translation failed: ${response.status}`)
  }

  return response.json()
}
